var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 26H18M10 26V19.3333M10 26H2.8C2.35817 26 2 25.6419 2 25.2V20.1333C2 19.6915 2.35817 19.3333 2.8 19.3333H10M18 26V10M18 26H25.2C25.6419 26 26 25.6419 26 25.2V2.8C26 2.35817 25.6419 2 25.2 2H18.8C18.3581 2 18 2.35817 18 2.8V10M10 19.3333V10.8C10 10.3582 10.3582 10 10.8 10H18",
    stroke: "url(#paint0_linear_404_2102)",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_404_2102",
    x1: 14,
    y1: 2,
    x2: 14,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3B438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC907"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReports);
export default __webpack_public_path__ + "static/media/icon-reports.087c03f0ba26d580b2c641c304454028.svg";
export { ForwardRef as ReactComponent };